export default __webpack_public_path__ + "static/media/category_energy_h.cbc4589d.svg";